import { ShowNotificationDetails as ShowNotificationDetailsPage } from './ShowNotificationDetails';
import { PageNotFound } from '@/app/core/components/PageNotFound';
import { PageContent } from '@/app/core/components/PageContent';
import { useSetPageTitle } from '@/app/store';
import { usePathContext } from '@ssar-app/okta-authn-react';
import { Route, Switch } from 'react-router-dom';

export const NotificationsPage = () => {
  useSetPageTitle('Notifications');
  // usePageTitleAndSubtitle('Notifications');
  const { buildPath } = usePathContext();
  return (
    <>
      <PageContent>
        <Switch>
          <Route path={buildPath(`/view/:notificationId`)}>
            <ShowNotificationDetailsPage />
          </Route>
          <Route path='*'>
            <PageNotFound />
          </Route>
        </Switch>
      </PageContent>
    </>
  );
};
